import ConfirmMyShare from "./ConfirmMyShare";
import EmergencyAccessInvitations from "./EmergencyAccessInvitations";

const noticeCardComponents = {
  ConfirmMyShare,
  EmergencyAccessInvitations
}

export default noticeCardComponents